import { render, staticRenderFns } from "./SiftCascader.vue?vue&type=template&id=9482c24e&scoped=true&"
import script from "./SiftCascader.vue?vue&type=script&lang=js&"
export * from "./SiftCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9482c24e",
  null
  
)

export default component.exports